import React from 'react';
import {
  ActionSectionStyled,
  ContentWrapperStyled,
  InfoKeyStyled,
  InfoValueStyled,
  PanelTitleStyled,
  ProposalInfoListStyled,
} from './styles';

interface InfoObject {
  [key: string]: string;
}

interface Props {
  title: string;
  mainInfo: InfoObject;
  actions?: React.ReactNode;
}

const ProposalInfoSection: React.FC<Props> = ({ title, mainInfo, actions }) => {
  return (
    <>
      <PanelTitleStyled>{title}</PanelTitleStyled>
      <ContentWrapperStyled>
        <ProposalInfoListStyled>
          {Object.keys(mainInfo).map((key) => (
            <li key={key}>
              <InfoKeyStyled>{key}:</InfoKeyStyled>
              <InfoValueStyled>{mainInfo[key]}</InfoValueStyled>
            </li>
          ))}
        </ProposalInfoListStyled>
        <ActionSectionStyled>{actions}</ActionSectionStyled>
      </ContentWrapperStyled>
    </>
  );
};

export default ProposalInfoSection;
